import { render } from "./keywords.vue?vue&type=template&id=28e69305&scoped=true"
import script from "./keywords.vue?vue&type=script&lang=js"
export * from "./keywords.vue?vue&type=script&lang=js"

import "./keywords.vue?vue&type=style&index=0&id=28e69305&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e69305"]])

export default __exports__